export const selectOptions = [
  'Black/African American',
  'White/Caucasian',
  'American Indian/Alaska Native',
  'Latino/Hispanic',
  'Asian',
  'Pacific Islander/Hawaiian'
];
